module.exports = __webpack_public_path__ + "img/Telegram.47c3b52b.png";